/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, memo } from "react";
import { Card, Image, Button } from "react-bootstrap";
import Emp_data_pic from "../../assets/images/Emp_data_pic.png";
import { AiOutlineSearch } from "react-icons/ai";
import { AutoComplete, DatePicker, Select } from "antd";
import "./report.css";
import moment from "moment";

import {
  Table,
  TableHeadCell,
  TableBody,
  TableBodyCell,
  TableHead,
} from "../setting/PatientPortalSettings/StyledComponents";
import { Tablerow } from "../patient/StyledComponent";
import { Decrypt_Value } from "../../MiddleWare/EncryptDecrypt";
import { Encrypt_Value } from "../schedule/EncryptDecrypt";
import axiosInstance from "../../axios/axios";
import Loader from "../popups/Loading";
import { parsePhoneForDisplay } from "../patient/ParsePhoneForDisplay";
import CustomSuffixIcon from "../popups/CustomSuffixIcon";

// const { RangePicker } = DatePicker;
const { Option } = Select;

function WriteOffAdjustmentReportTable() {
  // ---- states ----
  const [spinner, setspinner] = useState(true);

  // patient search states (same logic as EligibilityReport)
  const [search, setSearch] = useState("");
  const [patId, setPatId] = useState("");
  const [patsrchvalue, setpatsrchvalue] = useState("");
  const [forpatsrchload, setforpatsrchload] = useState(false);
  const [source, setSource] = useState([]);
  const [fornoresults, setfornoresults] = useState("1");

  // provider (if needed) - kept simple (you can wire like eligibility later)
  const [usersearch, setUserSearch] = useState("");
  // payer
  const [search2, setSearch2] = useState("");
  const [filterpayer, setfilterpayer] = useState([]);
  const [fornoresults1, setnoresult1] = useState("1");

  // facility
  const [office, setoffice] = useState("");
  const [alloffice, setalloffice] = useState([]);

  // date range
  const [fromdt, setfrom] = useState(
    moment().add(-7, "days").format("YYYY-MM-DD"),
  );
  const [todt, settodt] = useState(moment().format("YYYY-MM-DD"));

  // table data and pagination
  const [mainrows, setmainrows] = useState([]); // full data (either dummy or API)
  const [tableData, setTableData] = useState([]); // visible chunk (first N)
  const [showLoading, setShowLoading] = useState("none"); // load-more control
  const [offVal, setoffval] = useState(40);
  const [load_flag, setload_flag] = useState(0);
  const [payId, setPayId] = useState("");

  // writeoff type static
  const [writeoffType, setWriteoffType] = useState("");

  // small UI control
  const [showTitle, setShowTitle] = useState(true);

  // decrypt / config
  const dateFormat = localStorage.getItem("dateFormat") || "YYYY/MM/DD";
  const dtFormat = dateFormat;
  const storedNames = Decrypt_Value(localStorage.getItem("setroles"), "vozo");
  const authorized = Decrypt_Value(localStorage.getItem("authorized"), "vozo");
  const main_pro = Decrypt_Value(localStorage.getItem("main_pro"), "vozo");
  const owner_id = Decrypt_Value(localStorage.getItem("owner_id"), "vozo");
  const user_ID = Decrypt_Value(localStorage.getItem("user_id"), "vozo");

  // ---- dummy data (first load only) ----

  // ---- helpers ----
  const timeout = (ms) => new Promise((res) => setTimeout(res, ms));

  // patient select from dropdown
  const PatientSelect = (data) => {
    const a = data.split("-");
    setSearch(a[1]);
    setPatId(a[0]);
  };

  const PatientSearch = (data) => {
    setfornoresults("1");
    setSource([]);
    setforpatsrchload(true);
    setpatsrchvalue(data);
    setSearch(data);
    if (data === "") setPatId("");
  };

  // provider search handlers (kept minimal — you can wire like eligibility later)
  const UsersearchValue = (e) => {
    setUserSearch(e);
  };

  // payer handlers
  const payername = (data) => {
    const a = data.split("-");
    setSearch2(a[1]);
    setfilterpayer([]); // clear suggestions
    setnoresult1("1");
  };

  const payerchange = (data) => {
    setSearch2(data);
    setfilterpayer([]);
    setnoresult1("1");
    if (data === "") {
      // clear payer id logic if you store payer id separately
    }
  };

  // date range handler
  // const mydate = (e) => {
  //   if (e != null && e[0] && e[1]) {
  //     setfrom(moment(e[0], dateFormat).format("YYYY/MM/DD"));
  //     settodt(moment(e[1], dateFormat).format("YYYY/MM/DD"));
  //   } else {
  //     setfrom("");
  //     settodt("");
  //   }
  // };

  // ---- first load (dummy) ----
  const firstload = async () => {
    // show dummy first
    const article = {
      patientid: patId || "",
      type: writeoffType, // provider id if you want to support provider filter
      payerid: search2, // you can set payer id extraction if you save it
      startdate: fromdt,
      enddate: todt,
      facility: office || "",
      limit: 40,
      offset: 0,
      // authorized: authorized,
      // main_pro: main_pro,
      // owner_id: owner_id,
      // userID: user_ID,
      // pat_share: storedNames.pat_share,
    };
    // show spinner while fetching and reset current table
    setspinner(true);

    try {
      // encrypt & call backend (backend path placeholder)
      const d = Encrypt_Value(article, "vozo");
      // NOTE: replace '/vozo/getwriteoffreport' below with actual backend endpoint when available
      const res = await axiosInstance.put("/vozo/writeOffAdjustment", d);
      const decoded = Decrypt_Value(res.data, "vozo");
      // backend expected to return array of rows (same structure expected)
      if (decoded && decoded.length > 0) {
        setmainrows(decoded);
        setTableData(decoded.slice(0, 15));
        setShowLoading(decoded.length > 15 ? "block" : "none");
      } else {
        // no results from backend — show empty UI same as EligibilityReport
        setmainrows([]);
        setTableData([]);
        setShowLoading("none");
      }
    } catch (err) {
      // If backend not ready, keep empty result (this catch is safe while backend is absent)
      // Once backend is implemented, you can remove catch body or handle accordingly
      setmainrows([]);
      setTableData([]);
      setShowLoading("none");
    } finally {
      setspinner(false);
    }

    // fetch facility list in background (same as ProductProceduresTable)
    getFacilityDatas();
  };

  // ---- facility fetch (from ProductProceduresTable logic) ----
  const getFacilityDatas = async () => {
    try {
      const stored = Decrypt_Value(localStorage.getItem("setroles"), "vozo");
      const authorizedL = Decrypt_Value(
        localStorage.getItem("authorized"),
        "vozo",
      );
      const main_proL = Decrypt_Value(localStorage.getItem("main_pro"), "vozo");
      const group_id = Decrypt_Value(localStorage.getItem("group_id"), "vozo");
      let input =
        "authorized=" +
        authorizedL +
        "&main_pro=" +
        main_proL +
        "&group_id=" +
        group_id;
      let dta = Encrypt_Value(input, "vozo");
      const res = await axiosInstance.get(
        "/vozonew/facility/all?search=" + dta,
      );
      const decoded = Decrypt_Value(res.data, "vozo");
      setalloffice(decoded || []);
    } catch (err) {
      setalloffice([]);
    }
  };

  // ---- patient dropdown (same as eligibility) ----
  const patdropdown = async () => {
    try {
      let article =
        "limit=10&fname=" +
        search +
        "&authorized=" +
        authorized +
        "&main_pro=" +
        main_pro +
        "&userID=" +
        user_ID +
        "&pat_share=" +
        storedNames.pat_share +
        "&owner_id=" +
        owner_id;
      let data = Encrypt_Value(article, "vozo");
      const res = await axiosInstance.get("/vozo/patientsearch?search=" + data);
      const res3 = Decrypt_Value(res.data, "vozo");
      if (res3.length > 0) {
        setSource(res3);
        setfornoresults(res3);
      } else {
        setSource([]);
        setfornoresults("");
      }
    } catch (err) {
      setSource([]);
      setfornoresults("");
    }
  };

  // ---- payer dropdown (like Eligibility) ----
  const payerdropdown = async () => {
    try {
      let article1 = "limit=10&payer=" + search2;
      let data = Encrypt_Value(article1, "vozo");
      const res = await axiosInstance.get(
        "/vozonew/insurance_company/names?search=" + data,
      );
      const res3 = Decrypt_Value(res.data, "vozo");
      setfilterpayer(res3);
      setnoresult1(res3);
    } catch (err) {
      setfilterpayer([]);
      setnoresult1("");
    }
  };

  // ---- load more (keeps same behaviour as others; when backend present this will page) ----
  const loadMore = () => {
    // if mainrows already have more data push next slice
    const rowscount = tableData.length;
    if (mainrows.length > rowscount) {
      const next = mainrows.slice(rowscount, rowscount + 10);
      setTableData((prev) => [...prev, ...next]);
    } else {
      // if backend paging implemented later, trigger API (current dummy doesn't require)
      setShowLoading("none");
    }
  };

  // ---- onSubmit (Update) -> will build payload and call backend
  const onSubmit = async () => {
    // Build article like other reports
    const article = {
      patientid: patId || "",
      type: writeoffType, // provider id if you want to support provider filter
      payerid: search2, // you can set payer id extraction if you save it
      startdate: fromdt,
      enddate: todt,
      facility: office || "",
      limit: 40,
      offset: 0,
      // authorized: authorized,
      // main_pro: main_pro,
      // owner_id: owner_id,
      // userID: user_ID,
      // pat_share: storedNames.pat_share,
    };
    // show spinner while fetching and reset current table
    setspinner(true);

    try {
      // encrypt & call backend (backend path placeholder)
      const d = Encrypt_Value(article, "vozo");
      // NOTE: replace '/vozo/getwriteoffreport' below with actual backend endpoint when available
      const res = await axiosInstance.put("/vozo/writeOffAdjustment", d);
      const decoded = Decrypt_Value(res.data, "vozo");
      // backend expected to return array of rows (same structure expected)
      if (decoded && decoded.length > 0) {
        setmainrows(decoded);
        setTableData(decoded.slice(0, 15));
        setShowLoading(decoded.length > 15 ? "block" : "none");
      } else {
        // no results from backend — show empty UI same as EligibilityReport
        setmainrows([]);
        setTableData([]);
        setShowLoading("none");
      }
    } catch (err) {
      // If backend not ready, keep empty result (this catch is safe while backend is absent)
      // Once backend is implemented, you can remove catch body or handle accordingly
      setmainrows([]);
      setTableData([]);
      setShowLoading("none");
    } finally {
      setspinner(false);
    }
  };

  // ---- effects ----
  useEffect(() => {
    firstload();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    // patient search debounce
    let isCancelled = false;
    const handle = async () => {
      await timeout(700);
      if (!isCancelled && forpatsrchload) {
        patdropdown();
      }
    };
    handle();
    return () => {
      isCancelled = true;
    };
    // eslint-disable-next-line
  }, [patsrchvalue]);

  useEffect(() => {
    // payer debounce
    let isCancelled = false;
    const handle = async () => {
      await timeout(700);
      if (!isCancelled && search2 !== "") {
        payerdropdown();
      }
    };
    handle();
    return () => {
      isCancelled = true;
    };
    // eslint-disable-next-line
  }, [search2]);

  // ---- render ----
  return (
    <>
      {spinner ? (
        <Loader />
      ) : (
        <div>
          <div className="tab_title_main1">
            <div className="tab_title_name">Write Off/Adjustment Report</div>
          </div>

          <div className="daysheet-snd-layer rep-flex-align-center backgr-chng ">
            <style>{`
              /* Scoped placeholder fix for this filter area only */
              .claim-filter-wrap .ant-select-selection-placeholder {
                color: #444 !important;
                opacity: 1 !important;
              }
              /* keep AutoComplete placeholder readable */
              .claim-filter-wrap .ant-input::placeholder { color: #666; opacity: 1; }
            `}</style>
            <div>
              <div className="col-12 p-l-r-13 d-flex claimreportWrapBtom">
                {/* Patient Search (same logic as EligibilityReport) */}
                <div className="for_autoComplete_bi SearchUI m-t-8">
                  <AiOutlineSearch />
                  <AutoComplete
                    virtual={false}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    placeholder=" Patient "
                    className="remainderWidthSheet"
                    onSelect={(data) => PatientSelect(data)}
                    onChange={(data) => PatientSearch(data)}
                    dropdownClassName={search !== "" ? "" : "for_no_loading"}
                    dropdownRender={(menu) => (
                      <div
                        onMouseEnter={() => setShowTitle(false)}
                        onMouseLeave={() => setShowTitle(true)}
                      >
                        {menu}
                      </div>
                    )}
                    notFoundContent={
                      fornoresults.length !== 0
                        ? "loading.."
                        : "No Result Found"
                    }
                    onClick={() => {
                      if (search) patdropdown();
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") patdropdown();
                    }}
                    options={source.map((x) => {
                      const titleText = x.title || "";
                      const titleLength = titleText.length || 0;
                      return {
                        label: (
                          <div>
                            <div className="toplabel" title={titleText}>
                              {titleLength < 15 ? (
                                <>
                                  {x.title} -{" "}
                                  {x.dob ? moment(x.dob).format(dtFormat) : ""}
                                </>
                              ) : (
                                <>
                                  <div>{x.title} -</div>
                                  <div>
                                    {x.dob
                                      ? moment(x.dob).format(dtFormat)
                                      : ""}
                                  </div>
                                </>
                              )}
                            </div>
                            <div>
                              {(() => {
                                const { countryCode, phoneNumber } =
                                  parsePhoneForDisplay(
                                    (x.phone_cell || "").replace(
                                      /[^0-9+_ ]/g,
                                      "",
                                    ),
                                    [],
                                  );
                                return `${countryCode} ${phoneNumber}`.trim();
                              })()}
                            </div>
                          </div>
                        ),
                        value: x.pid + "-" + (x.name || x.title || ""),
                      };
                    })}
                    value={search}
                  />
                </div>

                {/* Facility dropdown (ProductProceduresTable style) */}
                <div className="rep-day-sht-btn m-t-16 demoPaymentControl">
                  <Select
                    virtual={false}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    placeholder="Facility"
                    className="w-100 t-a-l antd-dd-pay_anly"
                    onChange={(val) => setoffice(val)}
                    value={office ? office : undefined}
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      (option?.title ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {alloffice.map((row, ind) => (
                      <Option
                        key={row.officeid + ind}
                        value={row.officeid}
                        title={row.Office}
                      >
                        {row.Office}
                      </Option>
                    ))}
                  </Select>
                </div>

                {/* Payer (AutoComplete like Eligibility) */}
                <div className="for_autoComplete_bi SearchUI m-t-8">
                  <AiOutlineSearch />
                  <AutoComplete
                    virtual={false}
                    placeholder="Payer"
                    className="w-100 t-a-l payer-autocomplete"
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    value={search2}
                    onChange={(val) => {
                      setSearch2(val);
                      payerchange(val); // your API search call
                    }}
                    onSelect={(value, option) => {
                      setPayId(option.id); // store payer id
                      setSearch2(option.display); // show clean text in input
                    }}
                    notFoundContent={
                      filterpayer.length === 0
                        ? "No Result Found"
                        : "Loading..."
                    }
                    //  Dropdown list items
                    options={filterpayer.map((x) => ({
                      label: (
                        <div className="toplabel" title={x.name}>
                          {x.name}
                        </div>
                      ),
                      value: x.name, // what shows inside input
                      id: x.id,
                      display: x.name, // clean string (prevents [object Object])
                    }))}
                  />
                </div>

                {/* Write-Off Type (static) */}
                <div
                  className="rep-day-sht-btn m-t-16 demoPaymentControl"
                  style={{ marginRight: 10 }}
                >
                  <Select
                    virtual={false}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    placeholder="Write Off Type"
                    className="w-100 t-a-l antd-dd-pay_anly"
                    suffixIcon={<CustomSuffixIcon />}
                    onChange={(val) => setWriteoffType(val)}
                    value={writeoffType || undefined}
                  >
                    <Option value="IA">Insurance WriteOff</Option>
                    <Option value="PA">Patient WriteOff</Option>
                  </Select>
                </div>

                {/* Date Range */}
                {/* <div className="ds-flex1 " id="rpt_pay-inp_dt">
                  <RangePicker
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    defaultValue={[
                      moment(fromdt, "YYYY/MM/DD"),
                      moment(todt, "YYYY/MM/DD"),
                    ]}
                    format={dateFormat}
                    onChange={(e) => mydate(e)}
                    inputReadOnly={true}
                    allowClear={false}
                  />
                </div> */}

                <div
                  className="claim_report_date_picker writeoff_date_picker"
                  id="rpt_pay-inp_dt"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <span
                    style={{
                      fontWeight: 600,
                    }}
                  >
                    From
                  </span>

                  <DatePicker
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    value={fromdt ? moment(fromdt, "YYYY-MM-DD") : null}
                    format={dateFormat}
                    inputReadOnly
                    allowClear={false}
                    style={{ width: 120 }}
                    onChange={(date) => {
                      if (date) {
                        setfrom(moment(date).format("YYYY-MM-DD"));
                      }
                    }}
                  />

                  <span
                    style={{
                      fontWeight: 600,
                    }}
                  >
                    To
                  </span>

                  <DatePicker
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    value={todt ? moment(todt, "YYYY-MM-DD") : null}
                    format={dateFormat}
                    inputReadOnly
                    allowClear={false}
                    style={{ width: 120 }}
                    onChange={(date) => {
                      if (date) {
                        settodt(moment(date).format("YYYY-MM-DD"));
                      }
                    }}
                  />
                </div>

                {/* Update */}
                <div
                  className="rep-day-sht-btn m-t-16"
                  style={{ marginLeft: "24px" }}
                >
                  <Button
                    variant="primary"
                    className="btn-fnt-wgt button_Click_event_alt"
                    onClick={() => onSubmit()}
                  >
                    Update
                  </Button>
                </div>
              </div>

              <div className="text-left reportEmptyDiv"></div>
            </div>
          </div>

          {/* Table */}
          <div className="appoint_report_card prior_rep_card_table">
            <Card>
              <Card.Header>
                <div className="modif">
                  <div className="modif_left pat_flag_tit_alt1">
                    Write Off/Adjustment List
                  </div>
                </div>
              </Card.Header>

              <div className="bill_summary_table">
                <Table className="appt_rep_table_responsive">
                  <TableHead
                    className="Tab_content_Table_Header appt-head"
                    display="table-header-group"
                    height="40px"
                  >
                    <Tablerow className="schedule-head-row tr-no">
                      <TableHeadCell align="left">Patient</TableHeadCell>
                      <TableHeadCell align="left">DOS</TableHeadCell>
                      <TableHeadCell align="left">Provider</TableHeadCell>
                      <TableHeadCell align="left" style={{ width: "100px" }}>
                        Facility
                      </TableHeadCell>
                      <TableHeadCell align="left">
                        Invoice/Claim #
                      </TableHeadCell>
                      <TableHeadCell align="left">
                        <div className="table-header-multiline">
                          <span>Insurance</span>
                          <span>Payer</span>
                        </div>
                      </TableHeadCell>
                      <TableHeadCell align="left">
                        <div className="table-header-multiline">
                          <span>Billed</span>
                          <span>Amount</span>
                        </div>
                      </TableHeadCell>
                      <TableHeadCell align="left">
                        <div className="table-header-multiline">
                          <span>Write Off</span>
                          <span>Date</span>
                        </div>
                      </TableHeadCell>
                      <TableHeadCell align="left">
                        <div className="table-header-multiline">
                          <span>Write off</span>
                          <span>Type</span>
                        </div>
                      </TableHeadCell>
                      <TableHeadCell align="left">
                        <div className="table-header-multiline">
                          <span>Write off</span>
                          <span>Amount</span>
                        </div>
                      </TableHeadCell>
                    </Tablerow>
                  </TableHead>

                  <TableBody className="tble-over appt_tab_alt1">
                    {tableData.length > 0 ? (
                      tableData.map((row, idx) => (
                        <Tablerow
                          key={idx}
                          className="table-data-row schedule-body-row"
                          borderBottom="1px solid #cbd5e0"
                          padding="6px 0 6px 18px"
                          color="#636d73"
                          height="56px"
                        >
                          {/* <TableBodyCell lineHeight="20.02px">
                            {row.patient}
                          </TableBodyCell> */}
                          <TableBodyCell
                            lineHeight="20.02px"
                            title={row.patient?.length > 15 ? row.patient : ""}
                          >
                            {row.patient?.length > 15
                              ? row.patient.substring(0, 15) + "..."
                              : row.patient}
                          </TableBodyCell>
                          <TableBodyCell
                            align="left"
                            // className="appNameWieght"
                            lineHeight="20.02px"
                          >
                            {row.DOS ? moment(row.DOS).format(dtFormat) : "-"}
                          </TableBodyCell>
                          <TableBodyCell
                            align="left"
                            lineHeight="20.02px"
                            title={
                              row.provider?.length > 15 ? row.provider : ""
                            }
                          >
                            {row.provider?.length > 15
                              ? row.provider.substring(0, 15) + "..."
                              : row.provider}
                          </TableBodyCell>
                          <TableBodyCell
                            align="left"
                            lineHeight="20.02px"
                            title={
                              row.facility?.length > 15 ? row.facility : ""
                            }
                          >
                            {row.facility?.length > 15
                              ? row.facility.substring(0, 15) + "..."
                              : row.facility}
                          </TableBodyCell>

                          <TableBodyCell
                            align="left"
                            // className="appTextColor"
                            lineHeight="20.02px"
                          >
                            {row.write_off_type === "IA"
                              ? row.encounter
                              : row.invoice_claim.length === 0
                                ? row.encounter
                                : row.invoice_claim}
                          </TableBodyCell>
                          {/* <TableBodyCell align="left" lineHeight="20.02px">
                            {row.insurance_payer}
                          </TableBodyCell> */}
                          <TableBodyCell
                            align="left"
                            lineHeight="20.02px"
                            title={
                              row.insurance_payer?.length > 15
                                ? row.insurance_payer
                                : ""
                            }
                          >
                            {row.insurance_payer?.length > 15
                              ? row.insurance_payer.substring(0, 15) + "..."
                              : row.insurance_payer}
                          </TableBodyCell>
                          <TableBodyCell align="left" lineHeight="20.02px">
                            ${row.billed_amount}
                          </TableBodyCell>
                          <TableBodyCell align="left" lineHeight="20.02px">
                            {row.write_off_date
                              ? moment(row.write_off_date).format(dtFormat)
                              : "-"}
                          </TableBodyCell>
                          <TableBodyCell align="left" lineHeight="20.02px">
                            {row.write_off_type === "IA"
                              ? "Insurance WriteOff "
                              : row.write_off_type === "PA"
                                ? "Patient WriteOff "
                                : "-"}
                          </TableBodyCell>
                          <TableBodyCell align="left" lineHeight="20.02px">
                            ${row.write_off_amount}
                          </TableBodyCell>
                        </Tablerow>
                      ))
                    ) : (
                      <Tablerow className="bot_border">
                        <TableBodyCell
                          className="appCellCenter patpor_main_div"
                          colSpan={10}
                        >
                          <div className="img_top">
                            <Image
                              height="133px"
                              width="133px"
                              src={Emp_data_pic}
                            ></Image>
                          </div>
                        </TableBodyCell>
                      </Tablerow>
                    )}
                  </TableBody>
                </Table>
              </div>
            </Card>

            {/* Load more (visible if showLoading block and table has items) */}
            {tableData.length !== 0 && showLoading === "block" && (
              <div
                className="loading-more pat_flg_loadmore_btn_alt"
                style={{ display: showLoading }}
              >
                <Button
                  id="load-data"
                  style={{ paddingTop: 16 }}
                  variant="primary"
                  className="loading-more-div"
                  onClick={loadMore}
                >
                  Load more...
                </Button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default memo(WriteOffAdjustmentReportTable);
